import { Workbook } from 'exceljs';
import * as fs from 'file-saver';

// excel work
export default function getExcel(exelHeader, excelData, fileName) {

  /**To remove the header for action columns */
  exelHeader.filter((dt, index) => {
    return dt.accessor === "accessor" ? exelHeader.splice(index, 1) : exelHeader;
  })
  if (fileName === 'Octapharma End Of Month Inventory Source') {
    exelHeader.filter((dt, index) => {
      if (dt.accessor === "EndofMonthInventory") {
        exelHeader.splice(index, 1);
      }

    })
  }
  if (fileName === 'Chargeback Source Data') {
    exelHeader = [...exelHeader];
    exelHeader.unshift({})
    exelHeader.filter((dt, index) => {
      return dt.accessor === "DebitMemoNum" || dt.accessor === "TotalAmountRequested" ? exelHeader.splice(index, 1) : exelHeader;
    })

    exelHeader.filter((dt, index) => {
      return dt.accessor === "DistributorName" ? exelHeader.splice(index, 1) : exelHeader;
    })
    exelHeader.filter((dt, index) => {
      return dt.accessor === "TotalLineCount" ? exelHeader.splice(index, 1) : exelHeader;
    })
  }


  const header = [];
  exelHeader.map((col, cindex) => { header.push(exelHeader[cindex].Header); })
  const data = [];
  excelData.map((data1, pidex) => {
    let record_to_download = []
    exelHeader.map((col, cindex) => {
      record_to_download.push((excelData[pidex][exelHeader[cindex].accessor] == null ? "" : excelData[pidex][exelHeader[cindex].accessor]))
    })
    data.push(record_to_download)
  })
  let workbook = new Workbook();
  let worksheet = workbook.addWorksheet(fileName);


  // Adding row lable for octapharma inventory report
  if (fileName === 'Octapharma End Of Month Inventory Source') {
    let rows = worksheet.getRow(1);
    rows.getCell(1).value = 'CIBD Distributors';
    let rowss = worksheet.getRow(2);
    rowss.getCell(1).value = 'Acct # OF13200';
    let row = worksheet.getRow(5);
    row.getCell(2).value = `End of Month Inventory (${excelData[0]?.EndofMonthInventory})`;
    worksheet.getRow(8).values = [];
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = {
        wch: 50,
        width: 50,
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'B8DDED' },
        bgColor: { argb: 'fff' }
      }
      cell.font = { color: { argb: "fff" } };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
    worksheet.getRow(9).eachCell((cell) => {
      cell.font = { bold: true };
    });
  }
  else if (fileName === 'Chargeback Source Data') {
    let rows1 = worksheet.getRow(1);
    rows1.getCell(1).value = 'Header Info';
    rows1.getCell(1).font = { bold: true };
    let rows2 = worksheet.getRow(2);
    rows2.getCell(1).value = 'Distributor HIN #';
    rows2.getCell(1).font = { bold: true };
    rows2.getCell(2).value = excelData[0]?.DistributorName;
    let rows3 = worksheet.getRow(3);
    rows3.getCell(1).value = 'Debit Memo/Document #';
    rows3.getCell(1).font = { bold: true };
    rows3.getCell(2).value = excelData[0]?.DebitMemoNum;
    let rows4 = worksheet.getRow(4);
    rows4.getCell(1).value = 'Total line count';
    rows4.getCell(1).font = { bold: true };
    rows4.getCell(2).value = excelData[0]?.TotalLineCount;
    let row5 = worksheet.getRow(5);
    row5.getCell(1).value = 'Total Amount Requested';
    row5.getCell(1).font = { bold: true };
    row5.getCell(2).value = excelData[0]?.TotalAmountRequested;
    let row8 = worksheet.getRow(8)
    row8.getCell(2).value = 'Detail Line Data';
    row8.getCell(2).font = { bold: true };
    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.fill = {
        wch: 50,
        width: 50,
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'B8DDED' },
        bgColor: { argb: 'fff' }
      }
      cell.font = { color: { argb: "fff" } };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
    worksheet.getRow(9).eachCell((cell) => {
      cell.font = { bold: true };
    });
  }

  else {
    let headerRow = worksheet.addRow(header);
    // Cell Style  Fill and Border
    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.font.color = {color: {argb: 'FFFFFF'}}
      cell.fill = {
        wch: 50,
        width: 50,
        type: 'pattern',
        pattern: 'solid',
        textColor:'FFFFFF',
        // 3b61ad  fff
        // bgColor: { argb: 'FFFFFF' },
        fgColor: { argb: 'B8DDED' },
      }
      cell.font = { color: { argb: "fff" } };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
    });
  }
  worksheet.columns = [
    { width: 20 }, { width: 20 }, { width: 20 }, { width: 30 }, { width: 30 }, { width: 15 }, { width: 30 }, { width: 15 }
  ];
  data.forEach((d, i) => {
    let row = worksheet.addRow(d);
    row.eachCell((cell) => {
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
  });
  if (fileName === 'Octapharma End Of Month Inventory Source') {
    let rowsss = worksheet.getRow(10 + excelData.length);
    rowsss.getCell(6).value = 'Total';
    rowsss.getCell(6).font = { bold: true };
    rowsss.getCell(7).value = excelData[0]?.Total;
    rowsss.getCell(7).font = { bold: true };
    rowsss.eachCell((cell) => {
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
  }
  if (fileName === 'Chargeback Source Data') {
    let rowsss = worksheet.getRow(10 + excelData.length);
    rowsss.getCell(10).value = excelData[0]?.Total? (excelData[0]?.Total * 1).toFixed(2): "0.00";
    rowsss.getCell(10).font = { bold: true };
    rowsss.eachCell((cell) => {
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    });
  }
  workbook.xlsx.writeBuffer().then((data) => {
    let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    fs.saveAs(blob, fileName + '.xlsx');
  });
}